import { CustomerLocationsView } from "./locations/CustomerLocationsView";

const CustomerLocationsPage = () => <CustomerLocationsView />;

export { CustomerLocationsPage };
